import {SystemStatus} from "../../../gd/const/system-status"
import ProjectSession from "../project-session"

export default function Project_updateSystemStatus(project:ProjectSession, systemStatus:SystemStatus, renderCallback?:callback) {
    // renderCallback used to rerender selector when we cancel update (close non empty project)
    // console.log("updateSystemStatus newValue=", systemStatus, "current value=", this.systemStatus)

    if (!project.isFolder && !project.isTag && !project.isCategory && !project.isPage && !project.isLink && !project.isEmbed && !project.isView && !project.isWorkspace) {
        console.error("ERROR #PROJECT-STATUS-1 try update system status for non folder/tag/category/page/link/embed/view/workspace")
        return
    }

    // dont update to same value
    if (systemStatus === project.systemStatus) {
        return
    }

    // first try updating with force close = False
    const request = gd.api.Project.updateSystemStatus(project.id,systemStatus,false)
    request.done((response:any)=>{
        if (response === 'not-empty') {
            gd.modals.project.confirmCloseNotEmpty(project.id, null, systemStatus, (accepted:any)=>{
                // set value according to decision made in confirmation dialog

                if (accepted) {
                    // second attempt to update status but no reply is expected (close silently is close status is selected)
                    // make change callback when status update done
                    const requestWithForceClose = gd.api.Project.updateSystemStatus(project.id,systemStatus,true);
                    requestWithForceClose.done((response:any)=> {
                        // console.log("STATUS UPDATED !")
                    })

                } else {
                    // cancel callback
                    // console.log("cancel called", this.systemStatus)
                    if (renderCallback) renderCallback()
                }
            })
        } else {
            // changeCallback(newStatusValue);
            // console.log("status updated from first attempt ")
        }
    })
}